"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBillingHistory = void 0;
var getBillingHistory = function (orionBillingHistory, legacyBillingHistory) {
    var _a;
    return {
        orionBillingHistory: augmentBillingHistoryResponse(((_a = orionBillingHistory.billingSummary) === null || _a === void 0 ? void 0 : _a.billablePeriods) || []),
        legacyBillingHistory: (legacyBillingHistory === null || legacyBillingHistory === void 0 ? void 0 : legacyBillingHistory.statements) || [],
        migrationNotices: [],
    };
};
exports.getBillingHistory = getBillingHistory;
var getBillingPeriodId = function (history, period) { return __spreadArray([], __read(history), false).reverse().findIndex(function (_a) {
    var end = _a.end;
    return end === period.end;
}); };
var augmentBillingHistoryResponse = function (billingHistory) {
    var latestBillFound = false;
    return billingHistory.map(function (period) {
        var isLatestBill = !latestBillFound && period.isStatementAvailable ? true : false;
        if (isLatestBill) {
            latestBillFound = true;
        }
        return __assign(__assign({}, period), { periodId: getBillingPeriodId(billingHistory, period), isLatestBill: isLatestBill });
    });
};
